import {
  CREATE_DISPUTE,
  DELETE_DISPUTE,
  RESTORE_DISPUTE,
  RETRIEVE_DISPUTE,
  RETRIEVE_DISPUTE_DETAILS,
  RETRIEVE_DISPUTE_DETAILS_LOADING,
  RETRIEVE_DISPUTE_ERROR,
  RETRIEVE_DISPUTE_LOADING,
  UPDATE_DISPUTE_STATUS,
} from "../actions/types";

const initialState = {
  dispute: [],
  loadingDispute: false,
  errorDispute: null,
  totalDisputeCount: 0,
  disputeDetails: null,
  disputeDetailsLoading: false,
};

const disputeReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_DISPUTE_LOADING:
      return {
        ...state,
        loadingDispute: true,
        errorDispute: null, // Reset error state when loading starts
      };

    case RETRIEVE_DISPUTE:
      return {
        ...state,
        dispute: action.payload.disputes,
        totalDisputeCount: action.payload.totalCount,
        loadingDispute: false,
      };

    case RETRIEVE_DISPUTE_ERROR:
      return {
        ...state,
        errorDispute: action.payload, // Store error message
        loadingDispute: false,
      };
    case RETRIEVE_DISPUTE_DETAILS_LOADING:
      return {
        ...state,
        disputeDetailsLoading: true,
      };

    case RETRIEVE_DISPUTE_DETAILS:
      return {
        ...state,
        disputeDetails: action.payload,
        disputeDetailsLoading: false,
      };

    case UPDATE_DISPUTE_STATUS:

    case DELETE_DISPUTE:
    case RESTORE_DISPUTE:
      return {
        ...state,
        dispute: action.payload.rows,
        totalDisputeCount: action.payload.count,
      };

    default:
      return state;
  }
};

export default disputeReducer;
